//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MenuList from "./MenuAside/MenuList";
import BottomLinks from "./MenuAside/BottomLinks";
export default {
  components: {
    MenuList,
    BottomLinks
  },
  computed: {
    navLinks() {
      return this.getMenu?.data?.data?.items || []
    }
  },
  methods: {
    changeLang(lang) {
      this.$i18n.setLocale(lang)
    }
  },
  chimera: {
    getMenu() {
      return {
        url: `/api/menu/`,
        key: `main-menu`,
        params: {
          code: 'top',
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
  }
}
